import React, { useState } from 'react';
import { Modal } from '@wajeez-web/components/ui';
import { CommonModalProps } from './Types';
import { TextInput } from '@wajeez-web/components/ui';
import { Identity } from '@wajeez-web/core/api-base';
import { useBusinessSelector } from '@wajeez-web/stores/business-group';

interface AddUserModalProps
  extends CommonModalProps<Identity.CreateBusinessGroupUserInput> {
  title?: string;
}

const AddUserModal: React.FC<AddUserModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  title = 'Add User',
}) => {
  const [businessCreateNewUserValues, setCreateNewUserValues] =
    useState<Identity.CreateBusinessGroupUserInput>({
      userName: '',
      email: '',
      password: '',
    });

  const createStatus = useBusinessSelector(
    ({ businessGroupsUsers }) => businessGroupsUsers.create.status
  );
  const createAdminStatus = useBusinessSelector(
    ({ businessGroupsUsers }) => businessGroupsUsers.createAdmin.status
  );

  const handleUserValuesChange = (name: string, value: any) => {
    setCreateNewUserValues({ ...businessCreateNewUserValues, [name]: value });
  };
  return (
    <Modal
      title={title}
      open={isOpen}
      onClose={onClose}
      onSubmit={() => {
        onSubmit && onSubmit(businessCreateNewUserValues);
      }}
      loading={createStatus === 'loading' || createAdminStatus === 'loading'}
      alertTarget="modal"
    >
      <div className="space-y-2 scrollbar h-full">
        <TextInput
          required={true}
          label="Name"
          name="userName"
          value={businessCreateNewUserValues.userName}
          onChange={handleUserValuesChange}
        />
        <TextInput
          required={true}
          label="Email"
          name="email"
          value={businessCreateNewUserValues.email}
          onChange={handleUserValuesChange}
        />
        <TextInput
          required={true}
          label="Password"
          name="password"
          value={businessCreateNewUserValues.password}
          onChange={handleUserValuesChange}
        />
      </div>
    </Modal>
  );
};

export default AddUserModal;
